export const siteMeta = {
    businessName: "Vandaag Begin Ik",
    practitioner: "Rita Wilschut",
    siteUrl: "https://www.vandaag-begin-ik.nl",
    phone: "06 307 559 79",
    phoneHref: "tel:+31630755979",
    email: "rita-wilschut@vandaag-begin-ik.nl",
    emailHref: "mailto:rita-wilschut@vandaag-begin-ik.nl",
    tagline: "Leefstijl- en diëtistenpraktijk in Breda",
    description:
        "Vandaag Begin Ik is de leefstijl- en diëtistenpraktijk van Rita Wilschut in Breda voor persoonlijk advies over voeding, beweging en ontspanning.",
    socialImage: "/Final-Logo-01.png",
};

export const locations = [
    {
        title: "Club Pellikaan",
        street: "Bijster 30",
        city: "Breda",
    },
    {
        title: "Gezondheidscentrum Heusdenhout",
        street: "Draaiboom 119",
        city: "Breda",
    },
    {
        title: "dr. Muskee",
        street: "Pastoor Pottersplein 51",
        city: "Breda",
    },
];

export const spreekuren = {
    maandag: [
        { time: "08:00 - 12:00", location: "Pastoor Pottersplein 51" },
        { time: "13:00 - 17:00", location: "Draaiboom 119" },
    ],
    dinsdag: [
        { time: "07:00 - 11:00", location: "Draaiboom 119" },
        { time: "11:30 - 15:30", location: "Draaiboom 119" },
        { time: "16:00 - 20:00", location: "Draaiboom 119" },
    ],
    woensdag: [
        { time: "08:00 - 12:00", location: "Pastoor Pottersplein 51" },
        { time: "13:00 - 17:00", location: "Pastoor Pottersplein 51" },
    ],
    vrijdag: [{ time: "07:00 - 11:00", location: "Erasmusplein 4" }],
};
